// Aura's dark-mode `text`/`outlined` hover backgrounds are a ~4% color-mix tint of the
// severity color — practically invisible against a dark surface, so hovering a button
// reads as "nothing happened" (or worse, like the disabled state) instead of "this is
// clickable". Use the same neutral hover highlight the rest of the app already uses for
// affordance (`--p-content-hover-background`, see HoverHighlightDirective) so every
// button's hover state is clearly visible regardless of severity — the severity is still
// conveyed by the (unchanged) text color.
const hoverBackground = '{content.hoverBackground}';

const severities = {
  primary: { hoverBackground },
  secondary: { hoverBackground },
  success: { hoverBackground },
  info: { hoverBackground },
  warn: { hoverBackground },
  help: { hoverBackground },
  danger: { hoverBackground },
  contrast: { hoverBackground },
  plain: { hoverBackground },
};

export default {
  colorScheme: {
    dark: {
      text: severities,
      outlined: severities,
    },
  },
};
